<template>
  <NuxtPage />
</template>

<script setup lang="ts"></script>

<style lang="postcss">
  @import url('@tapp/layer-design-system/assets/styles/reset.css');

  @import url('@tapp/layer-design-system/assets/styles/typography.css');

  html {
    scroll-behavior: smooth;
    scroll-snap-type: y proximity;
  }

  body {
    scroll-behavior: smooth;
  }

  .mobile-only {
    @media (--screen-lg) {
      /* stylelint-disable-next-line declaration-no-important */
      display: none !important;
    }
  }
</style>
